import useGlobalContext from "./useGlobalContext.js";
const useTrackFlightsWebUseOfferPos = () => {
    const { isExcludedFromPosMigrationPhaseOne } = useGlobalContext();
    const isVariant = !isExcludedFromPosMigrationPhaseOne;
    return {
        isVariant
    };
};
export default useTrackFlightsWebUseOfferPos;
